import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter, usePathname, useSearchParams } from 'src/routes/hooks';

import { CONFIG } from 'src/config-global';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

export function AuthGuard({ children }) {
  const router = useRouter();
  const pathname = usePathname();

  const searchParams = useSearchParams();

  const { authenticated, loading, user } = useAuthContext();

  const [isChecking, setIsChecking] = useState(true);

  const employeeRoutes = ['/user', '/periodic-check/user-checklist'];

  const createQueryString = useCallback((name, value) => {
    const params = new URLSearchParams();
    params.set(name, value);
    return params.toString();
  }, []);

  const checkPermissions = async () => {
    if (loading) {
      return;
    }
    if (
      user?.role?.length === 1 &&
      user?.role?.[0]?.name === 'employee' &&
      !employeeRoutes.includes(pathname)
    ) {
      router.replace('/user'); // redirect only if user is not already on a valid route
      return;
    }
    if (!authenticated) {
      const { method } = CONFIG.auth;

      const signInPath = paths.auth.jwt.login;

      const href = `${signInPath}?${createQueryString('returnTo', `${pathname}?${searchParams.toString()}`)}`;

      router.replace(href);
      return;
    }

    setIsChecking(false);
  };

  useEffect(() => {
    checkPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, loading]);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
